import { useMutation, useQueryClient } from "@tanstack/react-query"
import { addCompanyToRfq } from "@/lib/api/rfq.api"
import { useAuthStore } from "@/store/auth.store"

export function useAddCompanyToRfq() {
  const accessToken = useAuthStore((s) => s.accessToken)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ rfqId, companyId }: { rfqId: string; companyId: string }) => {
      if (!accessToken) throw new Error("Not authenticated")
      return addCompanyToRfq(rfqId, companyId, accessToken)
    },
    onSuccess: (_, variables) => {
      // Invalidate queries to trigger refresh
      queryClient.invalidateQueries({ queryKey: ["buyer-rfq-detail", variables.rfqId] })
      queryClient.invalidateQueries({ queryKey: ["companies-by-rfq", variables.rfqId] })
      queryClient.invalidateQueries({ queryKey: ["admin-rfqs"] })
    },
    onError: (error: Error) => {
      console.error("Adding company to RFQ failed:", error.message)
    },
  })
}
